module.exports = __webpack_public_path__ + "img/graphic-novel-preview.af5f5cfd.jpg";